import styled from "styled-components";

export const LoginInputs = styled.div`
  position: relative;
  display: flex;
  padding-top: 7px;
  flex-direction: column;
`;

export const Label = styled.label`
  position: absolute;
  top: 25px;
  left: 8px;
  padding: 0 4px;
  color: ${(props) => props.theme.colors.inputPlaceholder};
  font-size: 1.3rem;
  transition: all 0.2s ease;
`;

export const Input = styled.input`
  width: 100%;
  height: 52px;
  padding: 0 12px;
  font-size: 1.4rem;
  background: ${(props) => props.theme.colors.mainBg};
  border: none;
  border-radius: 6px;
  transition: all 0.2s ease;

  &::placeholder {
    visibility: hidden;
    color: ${(props) => props.theme.colors.inputPlaceholder};
    font-size: 1.2rem;
    font-weight: 400;
  }

  &:not(:placeholder-shown) {
    outline: none;
    background: ${(props) => props.theme.colors.white100};
    border: 1px solid ${(props) => props.theme.colors.primary100};
    transition: all 0.2s ease;

    & + ${Label} {
      top: 0;
      left: 8px;
      color: ${(props) => props.theme.colors.primary100};
      background: ${(props) => props.theme.colors.white100};
      transition: all 0.2s ease;
    }
  }

  &:focus {
    outline: none;
    background: ${(props) => props.theme.colors.white100};
    border: 2px solid ${(props) => props.theme.colors.primary100};
    transition: all 0.2s ease;

    & + ${Label} {
      top: 0;
      left: 8px;
      color: ${(props) => props.theme.colors.primary100};
      background: ${(props) => props.theme.colors.white100};
      transition: all 0.2s ease;
    }

    &::placeholder {
      visibility: visible;
    }
  }
`;
